<div class="row">
    <div class="col-md-12 form-group">
        <ax-light-info>
            Execute um duplo clique para abrir o registro desejado.
        </ax-light-info>
    </div>

    <div class="col-md-12">
        <ax-panel title="Periodicidade Definidas para o Paciente">
            <div class="row">
                <div class="col-md-12">
                    <ejs-grid #grid
                    [dataSource]="registros"
                    [selectionSettings]="selecaoModelo"
                    [enableVirtualization]='true'  height='450' 
                    [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings'
                    [allowFiltering]='true' 
                    [allowSorting]='true' 
                    [allowResizing]='true' 
                    (recordDoubleClick)="abrirSelecao()"
                    [showColumnChooser]='true'
                    [showColumnMenu]='true'
                    [pageSettings]='{ pageSize: 100 }'
                    [allowExcelExport]='true'
                    [allowPdfExport]='true'
                    [allowPdfExport]='true'
                    >
                    <e-columns>
                        <e-column field='id' width='50' [headerText]="'Id'" [isPrimaryKey]="true" [visible]="true"></e-column>
                        <e-column field='exameNaturezaTexto' [headerText]="'Exame'" [visible]="true"></e-column>
                        <e-column field='periodicidadeTexto' [headerText]="'Periodicidade'"></e-column>
                        <e-column field='ativo' [headerText]="'Ativo'" >
                            <ng-template #template let-data>
                                <div>
                                <ejs-checkbox [disabled]="true" [checked]="data.ativo"></ejs-checkbox>
                                </div>
                            </ng-template>

                        </e-column>
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="id" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
                </div>
            </div>
        </ax-panel>
    </div>
</div>


<app-pessoa-exame-periodicidade-cadastro #periodicidadeCadastro [apenasConsulta]="true"></app-pessoa-exame-periodicidade-cadastro>